/*
    ---- Html ----
    Displays HTML
*/

import React from "react";

function Html(props) {

  const { html, className = "html htmlcolor" } = props;

  const display = () => {
    return { __html: html };
  }


  return (<><div style={{ "overflow": "hidden"}} className={className} dangerouslySetInnerHTML={display()}></div></>);

}

export default Html;